"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorStatusType = void 0;
var ErrorStatusType;
(function (ErrorStatusType) {
    ErrorStatusType["DOWNLOADING_AND_APPLYING_UPDATE"] = "Error downloading and applying update";
    ErrorStatusType["RESTARTING"] = "Error restarting";
    ErrorStatusType["DOWNLOADING_RELEASE"] = "Error downloading release";
    ErrorStatusType["APPLYING_RELEASE"] = "Error applying release";
    ErrorStatusType["APPLYING_CONFIG"] = "Error applying config";
})(ErrorStatusType = exports.ErrorStatusType || (exports.ErrorStatusType = {}));
//# sourceMappingURL=ErrorStatusType.js.map